import { testimonials } from '@/mocks/testimonials';

export default function Testimonials() {
  return (
    <section id="faq" className="w-full bg-background-100 py-20 md:py-28">
      <div className="w-full px-6 md:px-10 max-w-[1400px] mx-auto">
        <span className="inline-block px-4 py-1.5 bg-accent-100 text-accent-700 text-xs font-semibold rounded-full mb-6">
          Community Trust
        </span>
        <h2 className="font-heading text-4xl md:text-5xl font-bold text-foreground-950 max-w-3xl leading-tight mb-14">
          Trusted by thousands of<br />international shoppers
        </h2>

        {/* Masonry grid */}
        <div className="columns-1 md:columns-2 lg:columns-3 gap-5">
          {testimonials.map((t, i) => (
            <div
              key={i}
              className="break-inside-avoid mb-5 bg-background-50 rounded-xl p-6 border border-background-200/70"
            >
              <div className="flex items-center gap-3 mb-4">
                <div className={`w-10 h-10 rounded-full ${t.avatarBg} flex items-center justify-center flex-shrink-0`}>
                  <span className="text-sm font-bold text-background-50">
                    {t.name.charAt(0)}
                  </span>
                </div>
                <div>
                  <p className="text-sm font-semibold text-foreground-950">{t.name}</p>
                  <p className="text-xs text-foreground-400">{t.handle}</p>
                </div>
              </div>
              <p className="text-sm text-foreground-600 leading-relaxed">
                &ldquo;{t.content}&rdquo;
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}